import React, { useEffect } from 'react'
import { createAuthor } from "../firebase/authorUtils"; 

export default function NewUser(props) {
  console.log('onboarding')
  useEffect(() => {
    createAuthor()
    props.setNewUser(false);
  }, []); //First render only

  return null;
}
